import "./candidatesmap.scss";
import { inject, observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";

import { Form } from "react-bootstrap";
import Filter from "sharedComponents/Filter";

import OneCandidate from "./OneCandidate/index";

import plus from "images/plus.svg";
import { applyInfo } from "utils/functions";
import { sendMetriks } from "utils/metriks";

const СandidatesMap = ({
  showMoreCandidates,
  isLoadingForCandidates,
  candidates,
  cleanErrorAddition,
  candidatesCountAll,
  getCandidates,
  applications,
  setIsNewCandidate,
  clearOneCandidate,

  statusesTitles,
  noCandidatesError,
  setStatusIds,
  setIsCandidateModalOpen,
  setSelectedCandidate
}) => {
  const [checked, setChecked] = useState(null);

  useEffect(() => {
    getCandidates();
    return () => setStatusIds([]);
  }, []);

  useEffect(() => {
    if (checked) {
      let ids = [];
      for (const prop in checked) {
        checked[prop] && ids.push(prop);
      }
      setStatusIds(ids);
      getCandidates();
    }
  }, [checked]);

  const listInnerRef = useRef();
  const hasMoreCandidates = candidatesCountAll != candidates.length;

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      // scrollTop бывает дробным (масштаб страницы), поэтому сравниваем с допуском
      if (
        scrollHeight - scrollTop - clientHeight <= 1 &&
        hasMoreCandidates &&
        !isLoadingForCandidates
      ) {
        showMoreCandidates();
      }
    }
  };

  // На широком экране страница целиком помещается в блок: скролла нет,
  // onScroll не срабатывает. Догружаем, пока список не переполнит блок.
  useEffect(() => {
    const list = listInnerRef.current;
    if (list && hasMoreCandidates && list.scrollHeight <= list.clientHeight) {
      showMoreCandidates();
    }
  }, [candidates.length]);

  const setUnchecked = () => {
    const uncheckedAll = {};
    for (const prop in checked) {
      uncheckedAll[prop] = false;
    }
    setStatusIds([]);
    setChecked(uncheckedAll);
  };

  return (
    <div className="candidatesmap">
      <div className="candidatesmap__header d-flex justify-content-between align-items-center">
        <div>
          <button
            onClick={() => {
              setSelectedCandidate("");
              setIsNewCandidate(true);
              clearOneCandidate();
              setIsCandidateModalOpen(true);
              cleanErrorAddition();
              sendMetriks("reachGoal", "can_add_1");
              sendMetriks("reachGoal", "resp_1");
            }}
            className="d-flex align-items-center gap-2 w-auto candidatesmap-btn candidatesmap-btn_add"
          >
            <img src={plus} alt="" />
            <p className="m-0 candidatesmap-btn__text">Добавить кандидата</p>
          </button>
        </div>
        <div className="position-relative">
          <Filter
            title="Статус кандидата"
            disabled={checked && Object.values(checked).every((val) => !val)}
            handleFilter={setUnchecked}
          >
            <ul>
              {statusesTitles
                ? Object.keys(statusesTitles).map((key) => {
                    return (
                      <li key={key}>
                        <Form.Group className="d-flex align-items-center gap-2">
                          <Form.Check
                            type="checkbox"
                            id={key}
                            onChange={(e) => {
                              if (!checked) {
                                setChecked({});
                                setChecked({
                                  ...checked,
                                  [key]: e.target.checked
                                });
                              } else {
                                setChecked({
                                  ...checked,
                                  [key]: e.target.checked
                                });
                              }
                            }}
                            checked={checked && checked[key]}
                          />
                          <Form.Label className="m-0" htmlFor={key}>
                            {statusesTitles[key]}
                          </Form.Label>
                        </Form.Group>
                      </li>
                    );
                  })
                : null}
            </ul>
          </Filter>
        </div>
      </div>
      <div>
        {candidates && candidates.length ? (
          <>
            <div
              className="candidates-cards"
              onScroll={onScroll}
              ref={listInnerRef}
            >
              {candidates.map((candidate) => {
                let candidateApplications = 0;

                for (let i = 0; i < applications.length; ++i) {
                  if (applications[i]["candidate_id"] == candidate.id) {
                    candidateApplications = candidateApplications + 1;
                  }
                }

                const apllyInfo = applyInfo(candidate, statusesTitles);

                return (
                  <OneCandidate
                    key={candidate.id}
                    id={candidate.id}
                    number={candidate.number}
                    living_address={
                      candidate.non_resident !== "1"
                        ? candidate.region_of_residence
                        : candidate.registration
                    }
                    date_create={candidate.date_create}
                    firstname={candidate.name}
                    surname={candidate.surname}
                    patronymic={candidate.patronymic}
                    birthday={candidate.birthday}
                    apllyInfo={apllyInfo}
                    status_id={candidate.status_id}
                    vacancies_candidate_id_bring_data={
                      candidate.vacancies_candidate_id_bring_data
                    }
                  />
                );
              })}
            </div>
            {isLoadingForCandidates ? (
              <p className="mb-0 ms-2 candidatesmap-info">
                Пожалуйста, подождите...
              </p>
            ) : (
              ""
            )}
          </>
        ) : noCandidatesError ? (
          <>
            <p className="mb-2 mt-4 candidatesmap-info">{noCandidatesError}</p>
            <button
              className="candidatesmap-btn text-uppercase candidatesmap-btn_show-more"
              onClick={() => {
                setUnchecked();
                getCandidates();
              }}
            >
              Показать все записи
            </button>
          </>
        ) : (
          <p className="mb-0 mt-4 candidatesmap-info">
            Список кандидатов загружается или ни один кандидат пока не добавлен
          </p>
        )}
      </div>
    </div>
  );
};

export default inject(({ candidatesStore, modalWindows }) => {
  const {
    showMoreCandidates,

    applications,
    candidatesCountAll,
    cleanErrorAddition,
    isLoadingForCandidates,
    getCandidates,

    setIsNewCandidate,
    clearOneCandidate,

    statusesTitles,
    noCandidatesError,
    setStatusIds,
    getSettings,
    setSelectedCandidate
  } = candidatesStore;

  const { setIsCandidateModalOpen } = modalWindows;
  return {
    showMoreCandidates,
    applications,
    cleanErrorAddition,
    candidatesCountAll,
    isLoadingForCandidates,
    getCandidates,
    setIsNewCandidate,
    clearOneCandidate,

    statusesTitles,
    noCandidatesError,
    setStatusIds,
    getSettings,
    setIsCandidateModalOpen,
    setSelectedCandidate
  };
})(observer(СandidatesMap));
